angular.module('nv.components.sorter-col-input').constant('SorterColInputTypes', {
  TEXT: 'text',
  CHECKBOX: 'checkbox',
  DROPDOWN: 'dropdown',
  AUTOCOMPLETE: 'autocomplete',
  USER_PICKER: 'userpicker',
});
